import useResource from './useResource';

const useCoinRate = () => {
	const RESOURCE_URL = '/api/v1/admin/coin-rates';

	const {
		isLoading,
		isEmpty,
		isEditing,
		resource: coinRate,
		resources: coinRates,
		findOne: findCoinRate,
		findMany: findCoinRates,
		update: updateCoinRate,
		create: createCoinRate,
		save: saveCoinRate,
		destroy: deleteCoinRate,
		handleChange,
		reloadMany: reloadCoinRates,
		reloadOne: reloadCoinRate
	} = useResource({
		id: null,
		url: RESOURCE_URL,
		name: 'coin_rate'
	});

	return {
		isLoading,
		isEmpty,
		isEditing,
		coinRate,
		coinRates,
		findCoinRate,
		findCoinRates,
		updateCoinRate,
		createCoinRate,
		saveCoinRate,
		deleteCoinRate,
		handleChange,
		reloadCoinRates,
		reloadCoinRate
	};
};

export default useCoinRate;
